/**
 * Copyright ToolBelt Data Inc., 2021 All Rights Reserved
 */

import React, {useState, useRef} from 'react';
import {
    Form,
    FormGroup,
    FormLabel,
    Row,
    Col,
} from 'react-bootstrap';

import RadioGroup from "../../../common/components/RadioGroup";

import {useCSVReader} from "react-papaparse";
import {useDispatch, useSelector} from "react-redux";

import {
    resetFileHeaders,
    updateFileHeaders,
    updateFileName,
    updateListName,
    updateFileSize,
    updateInputSource, updateTextInput,
} from "./uploadSlice";

import BrowserWindowImage from '../../../common/assets/img/ToolbeltIcons_Artboard_17.png'
import FileImage from '../../../common/assets/img/ToolbeltIcons_Artboard_17.png'
import Image from "react-bootstrap/Image";
import Select from "react-select";
import config from "../../../config";
import Alert from "react-bootstrap/Alert";

function InputListSelection(props) {
    const {
        handleUploadFile
    } = props;
    const listSource = [
        {
            value: "FILE_UPLOAD", label: <>Upload</>
        },
        {
            value: "TEXT_INPUT", label: <> Text Input </>
        },
    ];

    const fileTypes = [
        {value: 'csv', label: 'Comma Separated Value (CSV)'}
    ];

    const uploadMetaState = useSelector(state => state.upload);
    const dispatch = useDispatch();
    const { CSVReader } = useCSVReader();

    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    
    // Local state for file upload tracking (like CreateInputContainer)
    const [fileSelected, setFileSelected] = useState(false);
    const [uploadFile, setUploadFile] = useState(null);
    const [uploadedFileName, setUploadedFileName] = useState('');
    const [uploadedFileSize, setUploadedFileSize] = useState(0);
    
    // Ref to capture filename from CSVReader
    const fileNameRef = useRef('');

    const handleOnDrop = (data, meta) => {
        // Clear previous state
        setFileSelected(false);
        setUploadFile(null);
        setUploadedFileName('');
        setUploadedFileSize(0);
        
        const sizeLimit = config.constants.sizeLimit;

        if (meta && meta.size > (sizeLimit * 1000000)) {
            setShowAlert(true);
            setAlertMessage('File size is not support.');
            return;
        }

        // Handle file upload from meta object (OLD API - doesn't work)
        // if (meta && meta.file) {
        //     handleUploadFile([meta.file]);
        // }

        if (data && data.length > 0 && data[0] && data[0].length > 0) {
            dispatch(updateFileHeaders({data: data[0]}));
            dispatch(updateInputSource('FILE_UPLOAD'));
        } else {
            console.warn('No data received from CSVReader:', { data, meta });
        }

        // Store file info in local state
        if (meta) {
            setUploadedFileSize(meta.size || 0);
        }

        // File URL will be set by CSVReader render props with actual filename
        // dispatch(updateFileUrl('uploaded'));
    }


    const handleOnError = (err, file, inputElem, reason) => {
        console.log(err)
    }

    const handleOnRemoveFile = (data) => {
        // Clear local state
        setFileSelected(false);
        setUploadFile(null);
        setUploadedFileName('');
        setUploadedFileSize(0);
        
        // Clear Redux state
        if (data && data.length > 0) {
            dispatch(resetFileHeaders());
        }
        dispatch(updateFileName(''));
        dispatch(updateFileSize(0));
    }

    const handleOnTextInputUpdate = (data) => {
        dispatch(updateTextInput(data));
        dispatch(updateInputSource('TEXT_INPUT'));
    }

    return (
        <>
            <Alert
                variant={"danger"}
                show={showAlert}
                onClose={() => setShowAlert(!showAlert)}
                dismissible
                transition={false}
            >
                {alertMessage}
            </Alert>
            <Form className="inputListSelectionContent">
                <FormGroup>
                    <Row>
                        <Col md="auto" className="label-text">
                            <FormLabel>Select your list source</FormLabel>
                        </Col>
                        <Col md="auto">
                            <RadioGroup
                                id={'ListSourceSelection'}
                                name={'ListSourceSelection'}
                                value={uploadMetaState.inputSource}
                                items={listSource}
                                onChange={selectedValue => dispatch(updateInputSource(selectedValue))}
                                radioButton
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {uploadMetaState.inputSource === 'FILE_UPLOAD'
                                && !fileSelected && (
                                    <CSVReader
                                        onUploadAccepted={(results) => {
                                            // Keep full PapaParse results (data, errors, meta)
                                            handleOnDrop(results.data, results.meta);
                                            
                                            // Store a non-empty object so validation passes
                                            setUploadFile({ name: "(uploaded via CSVReader)" });
                                            
                                            // Mark as selected for immediate UI updates
                                            setFileSelected(true);
                                        }}
                                        onUploadRejected={(results) => {
                                            handleOnError(results.errors, results.file);
                                        }}
                                        config={{preview: 10}}
                                    >
                                        {({
                                            getRootProps,
                                            acceptedFile,
                                            ProgressBar,
                                            getRemoveFileProps,
                                            Remove
                                        }) => {
                                            // Update filename in Redux when acceptedFile changes
                                            if (acceptedFile && acceptedFile.name !== fileNameRef.current) {
                                                fileNameRef.current = acceptedFile.name;
                                                
                                                // Call handleUploadFile with the acceptedFile (new API)
                                                if (handleUploadFile && acceptedFile) {
                                                    handleUploadFile([acceptedFile]);
                                                }
                                                
                                                // Sanitize filename to match validation regex: ^[A-Za-z0-9-\\ \\_\\.\\-\\(\\)]+$
                                                let sanitizedFileName = acceptedFile.name;
                                                
                                                // Keep file extension but sanitize the base name
                                                const lastDotIndex = sanitizedFileName.lastIndexOf('.');
                                                const baseName = lastDotIndex > 0 ? sanitizedFileName.substring(0, lastDotIndex) : sanitizedFileName;
                                                const extension = lastDotIndex > 0 ? sanitizedFileName.substring(lastDotIndex) : '';
                                                
                                                // Replace invalid characters with underscores in base name only
                                                const validBaseName = baseName.replace(/[^A-Za-z0-9\-_\.\(\)\s]/g, '_');
                                                
                                                // Ensure base name is not empty
                                                const finalBaseName = validBaseName.trim() || 'uploaded_file';
                                                
                                                // Reconstruct filename with extension
                                                const finalFileName = finalBaseName + extension;
                                                
                                                console.log('Original filename:', acceptedFile.name);
                                                console.log('Sanitized filename:', finalFileName);
                                                
                                                dispatch(updateFileName(finalFileName));
                                                dispatch(updateListName(finalBaseName)); // List name without extension
                                            }
                                            
                                            return (
                                            <>
                                                <div
                                                    {...getRootProps()}
                                                    style={{
                                                        alignItems: 'center',
                                                        border: 'dashed',
                                                        borderRadius: '20px',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        height: '100%',
                                                        justifyContent: 'center',
                                                        padding: '20px',
                                                        cursor: 'pointer'
                                                    }}
                                                >
                                                    {!acceptedFile && (
                                                        <div className="source-image">
                                                            <Image
                                                                src={BrowserWindowImage}
                                                                width="110"
                                                                alt="Browser Window Image"
                                                                fluid
                                                            />
                                                            <FormLabel>
                                                                <b>Drag n' drop your file here or click to select your file</b>
                                                            </FormLabel>
                                                        </div>
                                                    )}
                                                    {acceptedFile && (
                                                        <div style={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            padding: 20
                                                        }}>
                                                            <div style={{
                                                                color: '#fff',
                                                                backgroundColor: '#eee',
                                                                borderRadius: 3,
                                                                fontSize: 14,
                                                                lineHeight: 1,
                                                                padding: '0 0.4em',
                                                                marginBottom: 10
                                                            }}>
                                                                {acceptedFile.name}
                                                            </div>
                                                            <div style={{
                                                                color: '#fff',
                                                                backgroundColor: '#000',
                                                                borderRadius: 3,
                                                                lineHeight: 1,
                                                                marginBottom: '0.5em',
                                                                padding: '0 0.4em',
                                                            }}>
                                                                {acceptedFile.size} bytes
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                {acceptedFile && !fileSelected && (
                                                    <div style={{ marginTop: 10 }}>

                                                    </div>
                                                )}
                                                <ProgressBar style={{
                                                    backgroundColor: 'pink',
                                                }} />
                                            </>
                                            );
                                        }}
                                    </CSVReader>
                                )}
                            {uploadMetaState.inputSource === 'FILE_UPLOAD'
                                && fileSelected && (
                                    <div className="source-file">
                                        <Image
                                            src={FileImage}
                                            width="110"
                                            alt="File Image"
                                            fluid
                                        />
                                        <FormLabel>
                                            <span className="file-name">{uploadMetaState.fileName}</span> selected for upload
                                        </FormLabel>
                                        <Row className="source-file-type">
                                            <Col md={4} className="col-form-label">
                                                <FormLabel>
                                                    Data Type:
                                                </FormLabel>
                                            </Col>
                                            <Col md={8}>
                                                <Select
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    defaultValue={fileTypes[0]}
                                                    name="color"
                                                    options={fileTypes}
                                                    menuPortalTarget={document.body}
                                                    menuPosition={'absolute'}
                                                    styles={{menuPortal: base => ({...base, zIndex: 9999})}}
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                                )}
                            {uploadMetaState.inputSource === 'TEXT_INPUT' && (
                                <div className="source-text-input">
                                    <Row>
                                        <Col>
                                            <FormLabel>
                                                Type or Copy / Paste your list below.
                                            </FormLabel>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Control as="textarea" rows={5} value={uploadMetaState.rawTextInput}
                                                          onChange={
                                                              (e) => handleOnTextInputUpdate(e.target.value)}/>
                                        </Col>
                                    </Row>
                                </div>
                            )}
                        </Col>
                    </Row>
                </FormGroup>
            </Form>
        </>
    );
}


export default InputListSelection;
